module.exports = "<div class=\"code-cubes\" dir=\"ltr\">\n  <input\n    #cube\n    *ngFor=\"let i of indexes\"\n    (blur)=\"onBlur()\"\n    (input)=\"onInput(i, $event)\"\n    (keydown)=\"onKeyDown(i, $event)\"\n    (paste)=\"onPaste(i, $event)\"\n    [attr.aria-label]=\"'ספרה ' + (i + 1) + ' מתוך ' + length\"\n    [disabled]=\"disabled\"\n    [value]=\"digits[i]\"\n    autocomplete=\"one-time-code\"\n    class=\"cube\"\n    inputmode=\"numeric\"\n    type=\"text\"\n  />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/code-cubes/code-cubes.component.html
// module id = ./src/app/common/code-cubes/code-cubes.component.html
// module chunks = main